import flow from 'lodash/flow';
import range from 'lodash/range';
import { validate } from '../validators';
import { read } from './FillInTheBlankQuestion';
import { getServerValidationErrors, mapPropsToValidators } from '../validators';
import { commonQuestionState, updateWhy } from '../response/reducer';
import * as validatorMap from './validators';
import prefill from '../prefillAnswers';

const updateValue = action => state => ({
  ...state,
  values: state.values.map(
    (v, index) =>
      index === action.index
        ? {
            ...v,
            value: action.value,
          }
        : v
  ),
});

const updateIsTouched = action => state => ({
  ...state,
  values: state.values.map(
    (v, index) =>
      index === action.index
        ? {
            ...v,
            isTouched: true,
          }
        : v
  ),
});

const touchAll = state => ({
  ...state,
  values: state.values.map(value => ({
    ...value,
    isTouched: true,
  })),
});

// Initial state

const addFibState = (props, splitPrompt, numFields) => state => ({
  ...state,
  fieldValids: range(numFields).map(() => true),
  splitPrompt,
  values: range(numFields).map((v, index) => ({
    index,
    isTouched: false,
    value: prefill(props.tmap, index),
  })),
  validators: mapPropsToValidators(
    {
      required: props.required,
    },
    validatorMap
  ),
});

const countFields = splitPrompt =>
  splitPrompt.reduce(
    (count, seg) => (typeof seg === 'string' ? count : seg + 1),
    0
  );

const reducer = props => (state, action) => {
  if (state === undefined) {
    const splitPrompt = read(props.prompt);
    const numFields = countFields(splitPrompt);
    return flow(
      commonQuestionState(props),
      getServerValidationErrors(props),
      addFibState(props, splitPrompt, numFields)
    )({});
  }

  switch (action.type) {
    case 'FIB_CHANGE':
      return flow(updateValue(action), validate(action))(state);

    case 'FIB_BLUR':
      return flow(updateIsTouched(action), validate(action))(state);

    case 'WHY_CHANGE':
      return flow(updateWhy(action), validate(action))(state);

    case 'SUBMIT':
      return flow(touchAll, validate(action))(state);

    default:
      return state;
  }
};

export default reducer;
